'use client';
import { useState } from 'react';
import { Container, Nav, Navbar, Row, Col, Button } from 'react-bootstrap';
import './style.scss';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import HeaderCommon from '@/views/commonComponent/header/headerCommon';

const GetSupport = () => {
  const router = useRouter();

  const [selectedGetSupport, setselectGetSupport] = useState<string | null>('');

  var handleGetSupport = (e: any) => {
    setselectGetSupport(e.target.value);
  };
  return (
    <div className="get-support-page">
      <HeaderCommon />
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} md={10} xs={12}>
            <Row>
              <Col xs={12}>
                <div className="h1Heading">
                  <h1>Choose Your Path</h1>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6}>
                <div
                  className={`get-support-card innerCard1 ${selectedGetSupport === 'Advisor' ? 'active' : ''}`}
                >
                  <label htmlFor="Advisor">
                    <input
                      type="radio"
                      name="get-support"
                      id="Advisor"
                      value="Advisor"
                      onChange={handleGetSupport}
                    />
                    <h5>
                      I’m an Advisor, hiring<span>for a project</span>
                    </h5>
                  </label>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6}>
                <div
                  className={`get-support-card innerCard2 ${selectedGetSupport === 'Provider' ? 'active' : ''}`}
                >
                  <label htmlFor="Provider">
                    <input
                      type="radio"
                      name="get-support"
                      id="Provider"
                      value="Provider"
                      onChange={handleGetSupport}
                    />
                    <h5>
                      I’m a Service Provider,<span>looking for Work</span>
                    </h5>
                  </label>
                </div>
              </Col>
              <Col xs={12}>
                <div className="continueButton">
                  <Button
                    disabled={selectedGetSupport == '' ? true : false}
                    className="primaryButton-AnchorTag"
                  >
                    <Link
                      href={{
                        pathname: '/auth/signup',
                        query: { data: selectedGetSupport },
                      }}
                    >
                      Continue
                    </Link>{' '}
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default GetSupport;
